<div class="modal-container">
    <h6 class="title">Seleccionar tipo de jornada</h6>
    <p class="subtitle">Elige cómo deseas registrar el día</p>

    <div class="options">
        <mat-card class="option-card" [class.selected]="jornada === 'completa'" (click)="seleccionarJornada('completa')"
            *ngIf="data?.dias >= 1">
            <mat-icon>event_available</mat-icon>
            <span>Jornada completa</span>
        </mat-card>

        <mat-card class="option-card" [class.selected]="jornada === 'media'" (click)="seleccionarJornada('media')">
            <mat-icon>schedule</mat-icon>
            <span>Media jornada</span>
        </mat-card>
    </div>

    <div *ngIf="jornada === 'media'" class="turno-options">
        <p class="subtitle">Seleccionar turno</p>

        <mat-card class="option-card small" [class.selected]="turno === 'mañana'" (click)="seleccionarTurno('mañana')">
            <mat-icon>wb_sunny</mat-icon>
            <span>Mañana</span>
        </mat-card>

        <mat-card class="option-card small" [class.selected]="turno === 'tarde'" (click)="seleccionarTurno('tarde')">
            <mat-icon>nights_stay</mat-icon>
            <span>Tarde</span>
        </mat-card>
    </div>

    <div class="actions">
        <button mat-stroked-button color="warn" (click)="cancelar()">
            Cancelar
        </button>
    </div>
</div>